// Should be an enum, but cannot use it due to the ancient, pre-historic version of Typescript.
export const MeansOfNotification = {
  Amelioration: 'amelioration',
  Popup: 'popup',
};
